import { useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import appStoreBadge from "../assets/images/apple-logo.png";
import playStoreBadge from "../assets/images/google-play.png";
import logo from "../logo.svg";
import shuchilogo from '../assets/images/shuchiai.png'

// API base URL configuration: uses full URL in production, empty in development to use local proxy
const API_BASE = process.env.NODE_ENV === "production" ? "https://shuchiai.com" : "";

// Default images list (replace or pass via props)

export default function MobileOnlySlider({ bgColor = "#1b2640" }) {
  const [current, setCurrent] = useState(0);
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(API_BASE + "/lulto_admin/api/apps")

      .then((res) => {
        // Ensure res.data is an array. If it's an object with an 'apps' property, use that.
        const appsData = Array.isArray(res.data) ? res.data : (res.data?.apps || []);
        setApps(appsData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // autoplaySpeed: 500,
    beforeChange: (_, next) => setCurrent(next),
    appendDots: (dots) => (
      <div style={{ bottom: "-2px" }}>
        <ul className="custom-dots">{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <button
        type="button"
        className={`dot ${current === i ? "active" : ""}`}
        aria-label={`Go to slide ${i + 1}`}
      ></button>
    ),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="mockup-wrap" style={{ background: bgColor }} id='our-apps'>
      <h2 className="section-title">Featured Apps</h2>
      {Array.isArray(apps) && apps.map((app, index) => {
        const isEven = index % 2 === 0; // even index → image right, odd index → image left

        return (
          <div key={app._id || index} className="sticky-content-block" style={{ zIndex: index + 1 }}>
            {isEven ? (
              <>
                <div className="row sliderbg">
                  <div className="col-left">
                    <div className="left-ticks" aria-hidden="true">
                      {app.imageUrls.map((_, i) => (
                        <span
                          key={i}
                          className={`tick ${current === i ? "active" : ""}`}
                        ></span>
                      ))}
                    </div>
                    <div className="shell">
                      <div className="phone">
                        <div className="screen">
                          <div className="slide-pad">
                            <Slider {...settings}>
                              {app.imageUrls?.map((url, i) => (
                                <div key={i}>
                                  <div className="media">
                                    <img src={url} />
                                  </div>
                                </div>
                              ))}
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-right">
                    <div className="main-div">
                      <div className="app-logo-wrapper">
                        <img src={app.logo || (index === 0 ? shuchilogo : logo)} alt="Logo" className="app-logo" />
                      </div>
                      <h2 className="heading">{app.title}</h2>
                      <p className="lead">{app.description}</p>
                      {app.websiteUrl && (
                        <a
                          href={app.websiteUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="website-button"
                        >
                          Go to Website
                        </a>
                      )}
                    </div>
                    <div className="second-div">
                      <div className="store-buttons">
                        {app.webStoreUrl && (
                          <a
                            className="store-btn-badge img-fluid"
                            href={app.webStoreUrl}
                            target="_blank"
                            aria-label="Get it on Google Play"
                          >
                            <img
                              src={playStoreBadge}
                              alt="Get it on Google Play"
                            />
                          </a>
                        )}
                        {app.appStoreUrl && (
                          <a
                            className="store-btn-badge img-fluid"
                            href={app.appStoreUrl}
                            target="_blank"
                            aria-label="Download on the App Store"
                          >
                            <img
                              src={appStoreBadge}
                              alt="Download on the App Store"
                            />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row sliderbg">
                  <div className="col-right">
                    <div className="main-div">
                      <div className="app-logo-wrapper">
                        <img src={app.logo || (index === 0 ? shuchilogo : logo)} alt="Logo" className="app-logo" />
                      </div>
                      <h2 className="heading">{app.title}</h2>
                      <p className="lead">{app.description}</p>
                      {app.websiteUrl && (
                        <a
                          href={app.websiteUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="website-button"
                        >
                          Go to Website
                        </a>
                      )}
                    </div>
                    <div className="second-div">
                      <div className="store-buttons">
                        {app.webStoreUrl && (
                          <a
                            className="store-btn-badge"
                            href={app.webStoreUrl}
                            target="_blank"
                            aria-label="Get it on Google Play"
                          >
                            <img
                              src={playStoreBadge}
                              alt="Get it on Google Play"
                            />
                          </a>
                        )}
                        {app.appStoreUrl && (
                          <a
                            className="store-btn-badge"
                            href={app.appStoreUrl}
                            target="_blank"
                            aria-label="Download on the App Store"
                          >
                            <img
                              src={appStoreBadge}
                              alt="Download on the App Store"
                            />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-left">
                    <div className="left-ticks" aria-hidden="true">
                      {app.imageUrls.map((_, i) => (
                        <span
                          key={i}
                          className={`tick ${current === i ? "active" : ""}`}
                        ></span>
                      ))}
                    </div>
                    <div className="shell">
                      <div className="phone">
                        <div className="screen">
                          <div className="slide-pad">
                            <Slider {...settings}>
                              {app.imageUrls?.map((url, i) => (
                                <div key={i}>
                                  <div className="media">
                                    <img src={url} />
                                  </div>
                                </div>
                              ))}
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        );
      })}
    </section>
  );
}


// import { useEffect, useState } from "react";
// import axios from "axios";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import appStoreBadge from "../assets/images/btn_appstore.svg";
// import playStoreBadge from "../assets/images/btn_googleplay.svg";

// export default function MobileOnlySlider() {
//   const [apps, setApps] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // ✅ Fetch Data from Backend
//   useEffect(() => {
//     axios
//       .get("http://localhost:5000/api/apps")
//       .then((res) => {
//         setApps(res.data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("API Error:", err);
//         setLoading(false);
//       });
//   }, []);

//   // ✅ Slick Slider Settings
//   const settings = {
//     dots: false,
//     arrows: false,
//     infinite: true,
//     speed: 400,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//   };

//   if (loading) {
//     return (
//       <div style={{ textAlign: "center", padding: "50px", color: "#fff" }}>
//         Loading apps...
//       </div>
//     );
//   }

//   if (!apps || apps.length === 0) {
//     return (
//       <div style={{ textAlign: "center", padding: "50px", color: "#fff" }}>
//         No app data found.
//       </div>
//     );
//   }

//   // ✅ Loop through each app & alternate sections
//   return (
//     <>
//       {apps.map((app, index) => {
//         const isEven = index % 2 === 0; // even index → image right, odd index → image left

//         return (
//           <section
//             key={app._id}
//             className={`mockup-wrap ${isEven ? "left-section" : "mosl-left"}`}
//             // style={{ background: "#1b2640" }}
//           >
//             <div className="row">
//               {isEven ? (
//                 // ✅ Section Type A: Image Right
//                 <>
//                   {/* Left Content */}
//                   <div className="col-left">
//                     <h2 className="heading">{app.title}</h2>
//                     <p className="lead">{app.description}</p>
//                     <div className="store-buttons">
//                       <a
//                         className="store-btn-badge"
//                         href={app.appStoreUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <img src={playStoreBadge} alt="Get it on Google Play" />
//                       </a>
//                       <a
//                         className="store-btn-badge"
//                         href={app.webStoreUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <img src={appStoreBadge} alt="Download on App Store" />
//                       </a>
//                     </div>
//                   </div>

//                   {/* Right Image */}
//                   <div className="col-right">
//                     <div className="shell">
//                       <div className="phone">
//                         <div className="screen">
//                           <div className="slide-pad">
//                             <Slider {...settings}>
//                               <div>
//                                 <div className="media">
//                                   <img
//                                     src={`http://localhost:5000${app.imageUrl}`}
//                                     alt={app.title}
//                                   />
//                                 </div>
//                               </div>
//                             </Slider>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </>
//               ) : (
//                 // ✅ Section Type B: Image Left
//                 <>
//                   {/* Left Image */}
//                   <div className="col-left">
//                     <div className="shell">
//                       <div className="phone">
//                         <div className="screen">
//                           <div className="slide-pad">
//                             <Slider {...settings}>
//                               <div>
//                                 <div className="media">
//                                   <img
//                                     src={`http://localhost:5000${app.imageUrl}`}
//                                     alt={app.title}
//                                   />
//                                 </div>
//                               </div>
//                             </Slider>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Right Content */}
//                   <div className="col-right">
//                     <h2 className="heading">{app.title}</h2>
//                     <p className="lead">{app.description}</p>
//                     <div className="store-buttons">
//                       <a
//                         className="store-btn-badge"
//                         href={app.appStoreUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <img src={playStoreBadge} alt="Get it on Google Play" />
//                       </a>
//                       <a
//                         className="store-btn-badge"
//                         href={app.webStoreUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <img src={appStoreBadge} alt="Download on App Store" />
//                       </a>
//                     </div>
//                   </div>
//                 </>
//               )}
//             </div>
//           </section>
//         );
//       })}
//     </>
//   );
// }
